import React, { useState } from 'react';

const HANDSHAKE_ICON = '/assets/images/page/icon-handshake.png';
const HANDSHAKE_TINT_FILTER = 'brightness(0) saturate(100%) invert(68%) sepia(15%) saturate(402%) hue-rotate(174deg) brightness(89%) contrast(86%)';

/**
 * 썸네일 미지정/404 대체 UI
 * - 회색 배경 위 중앙에 handshake 아이콘 표시
 */
const AllianceThumbnailFallback = ({
  className = '',
  style = {},
  iconSize = '80%',
  useTint = true,
  tintFilter = HANDSHAKE_TINT_FILTER,
}) => {
  const [iconBroken, setIconBroken] = useState(false);
  const normalizedIconSize = typeof iconSize === 'number' ? `${iconSize}px` : iconSize;

  return (
    <div
      className={`alliance-thumbnail-fallback ${className}`.trim()}
      style={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#e5e7eb',
        zIndex: 0,
        ...style,
      }}
      aria-hidden="true"
    >
      {!iconBroken && (
        <img
          src={HANDSHAKE_ICON}
          alt=""
          style={{
            width: normalizedIconSize,
            height: normalizedIconSize,
            objectFit: 'contain',
            pointerEvents: 'none',
            filter: useTint ? tintFilter : 'none',
          }}
          decoding="async"
          draggable={false}
          onError={() => setIconBroken(true)}
        />
      )}
    </div>
  );
};

export default AllianceThumbnailFallback;
